import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";

export const MidCTA = () => (
  <section className="py-20 md:py-28" data-testid="midpage-cta-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="rounded-3xl border border-[#171717]/10 bg-white/50 px-8 md:px-14 py-14 md:py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8"
      >
        <p className="font-heading text-2xl md:text-3xl leading-snug tracking-tight font-medium text-[#171717] max-w-[480px]">
          A simpler, more intelligent way to understand your health.
        </p>
        <CTAButton eventName="midpage_cta_click" size="md" testId="midpage-cta-waitlist" />
      </motion.div>
    </div>
  </section>
);
